import type { BaseAppError } from '@modules/core/errors';
import type { ISettingAffiliateBannerResponse } from '@modules/general-settings/submodules/affiliate-banner/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  ADMIN_GENERAL_SETTINGS_AFFILIATE_BANNER_PERMISSIONS,
  SETTINGS_AFFILIATE_BANNER_SAVE_QUERY_KEY,
  SETTINGS_AFFILIATE_BANNER_URL,
} from '@modules/general-settings/submodules/affiliate-banner/constants';
import { useToastStore } from '@modules/toast/store';

export default function useSettingsAffiliateBannerSaveMutation(): ReturnType<
  typeof useContextMutation<ISettingAffiliateBannerResponse, Error | BaseAppError, FormData>
> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<
    ISettingAffiliateBannerResponse,
Error | BaseAppError,
FormData
  >({
    mutationKey: [SETTINGS_AFFILIATE_BANNER_SAVE_QUERY_KEY],
    mutationFn: (payload) => fetchPut<ISettingAffiliateBannerResponse>(
      SETTINGS_AFFILIATE_BANNER_URL,
      payload,
      {
        permission: ADMIN_GENERAL_SETTINGS_AFFILIATE_BANNER_PERMISSIONS.BANNERSETTINGS_EDIT,
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [SETTINGS_AFFILIATE_BANNER_SAVE_QUERY_KEY] });
      displayPresetToast('edited');
    },
  });
}
